(() => {
  const tools = document.querySelector('.bz-grid-tools');
  const top = tools?.querySelector('.bz-to-top');
  top?.addEventListener('click', () => { window.scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}); });
  function visibility() {
    if (!tools) return;
    const hasCards = !!document.querySelector('.bz-grid-card');
    if (top) top.hidden = window.scrollY < 600;
    tools.hidden = !hasCards || !top || top.hidden;
  }
  let tick = false;
  if (tools) window.addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(() => { visibility(); tick = false; }); } }, {passive:true});
  visibility();
  /* Brand mixing now lives in the collections themselves (manual, brand-interleaved order set in Shopify admin),
     so the grid shows straight away; no pages are fetched up front. The old hide-until-mixed class is cleared. */
  document.documentElement.classList.remove('bz-shuf');
  const grid = document.querySelector('[data-bz-grid]');
  const more = document.querySelector('[data-bz-more]');
  if (!grid || !more || !('IntersectionObserver' in window)) return;

  let seen = new Set([...grid.children].map(el => el.querySelector('a[href]')?.getAttribute('href')));
  const link = more.querySelector('[data-bz-next]');
  const status = more.querySelector('[data-bz-status]');
  const pagination = document.querySelector('[data-bz-pagination]');
  let busy = false;
  let autoLoads = 0;
  more.hidden = false;
  if (pagination) pagination.hidden = true;
  const observer = new IntersectionObserver(entries => { if (entries.some(e => e.isIntersecting) && autoLoads < 3) load(false); }, {rootMargin:'300px'});
  observer.observe(more);
  async function load(manual) {
    if (busy || !link.getAttribute('href')) return;
    busy = true;
    observer.unobserve(more);
    link.setAttribute('aria-disabled','true');
    status.textContent = status.dataset.loading;
    try {
      const url = new URL(link.href, location.origin);
      if (url.origin !== location.origin) throw new Error('Invalid page');
      url.searchParams.set('section_id', grid.dataset.id);
      const response = await fetch(url, {credentials:'same-origin'});
      if (!response.ok) throw new Error('Page unavailable');
      const doc = new DOMParser().parseFromString(await response.text(),'text/html');
      const nextGrid = doc.querySelector('[data-bz-grid]');
      if (!nextGrid) throw new Error('Missing grid');
      const fragment = document.createDocumentFragment();
      for (const child of [...nextGrid.children]) {
        const key = child.querySelector('a[href]')?.getAttribute('href');
        if (seen.has(key)) continue;
        seen.add(key);
        child.classList.remove('scroll-trigger','animate--slide-in');
        child.querySelectorAll('script,link[rel="stylesheet"]').forEach(el=>el.remove());
        child.querySelectorAll('img').forEach(img=>img.loading='lazy');
        fragment.append(child);
      }
      grid.append(fragment);
      const next = doc.querySelector('[data-bz-next]');
      autoLoads = manual ? 0 : autoLoads + 1;
      if (next) { link.href = next.getAttribute('href'); status.textContent = ''; if (autoLoads < 3) observer.observe(more); }
      else { link.hidden = true; link.removeAttribute('href'); status.textContent = status.dataset.done; observer.disconnect(); }
      visibility();
    } catch (_) {
      status.textContent = status.dataset.error;
      autoLoads = 3;
    } finally {
      busy = false;
      link.removeAttribute('aria-disabled');
    }
  }
  link.addEventListener('click', event => { if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return; event.preventDefault(); load(true); });
})();
